module.exports = __webpack_public_path__ + "img/bhavna_video_thumbnail.bbbd9eed.jpg";